module.exports = {"title":"Readings","azName":"Strike Azimuth / Dip *","qdName":"Strike Bearing / Dip","ddName":"Dip Direction / Dip","azTooltip":"* According to the right hand rule."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/readings/en/messages.json
// module id = 154
// module chunks = 0